var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.editing,
          expression: "editing"
        }
      ],
      staticClass: "toolbar u-tile"
    },
    [
      _c(
        "a",
        {
          staticClass: "action",
          on: {
            click: function($event) {
              return _vm.object("text")
            }
          }
        },
        [_c("icon-text")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "action image" },
        [
          _c("input", {
            staticClass: "u-stretch",
            attrs: { type: "file", accept: ".png, .jpg, .jpeg" },
            on: { change: _vm.file }
          }),
          _vm._v(" "),
          _c("icon-image")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "action",
          on: {
            click: function($event) {
              return _vm.object("rect")
            }
          }
        },
        [_c("icon-rect")],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }